import type { IStore } from '~/rpcMethods'

type Google = typeof google

const infoWindow = ref<google.maps.InfoWindow>()

const currentStore = ref<IStore | undefined>(undefined)

export const useMapInfoWindow = () => {
  const newInfoWindow = (google: Google) => {
    const { InfoWindow } = google.maps
    infoWindow.value = new InfoWindow()
  }

  const setCurrentStore = (store: IStore | undefined) => {
    currentStore.value = store
  }

  return {
    infoWindow,
    currentStore,
    newInfoWindow,
    setCurrentStore,
  }
}
